import { render, staticRenderFns } from "./PayrollHistory.vue?vue&type=template&id=6575d382"
import script from "./PayrollHistory.vue?vue&type=script&lang=js"
export * from "./PayrollHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports